document.addEventListener('DOMContentLoaded', function () {

  const closeButton = document.getElementById('mfStickyAtcClose');
  let isDismissed = false;

  if (closeButton) {
    closeButton.addEventListener('click', function () {
      isDismissed = true;
      stickyBar.classList.remove('is-visible');
      stickyBar.classList.add('is-dismissed');
    });
  }
  const stickyBar = document.getElementById('mfStickyAtc');
  const stickyButton = document.getElementById('mfStickyAtcButton');

  if (!stickyBar || !stickyButton) return;

  const mainAtcButton = document.querySelector(
    'button[name="add"][type="submit"], form[action*="/cart/add"] [type="submit"]'
  );

  if (!mainAtcButton) return;

  const stickyPrice = document.getElementById('mfStickyAtcPrice');
  const stickyComparePrice = document.getElementById('mfStickyAtcComparePrice');
  const stickyImage = document.getElementById('mfStickyAtcImage');

  // ============================================
  // 1. SAFE SYNC FUNCTION
  // ============================================
  function syncStickyWithMainProduct() {
    // A. Sync Prices
    const mainPriceWrapper = document.querySelector(
      '.product .price, .product-single__price, .price-container, [data-price-container]'
    );

    if (mainPriceWrapper && stickyPrice) {
      const isOnSale = mainPriceWrapper.classList.contains('price--on-sale');

      if (isOnSale) {
        const salePriceEl = mainPriceWrapper.querySelector('.price__sale .price-item--sale, .price-item--sale');
        const comparePriceEl = mainPriceWrapper.querySelector('.price__sale .price-item--regular, s.price-item');

        if (salePriceEl && salePriceEl.textContent.trim()) {
          stickyPrice.textContent = salePriceEl.textContent.trim();
        }
        if (stickyComparePrice && comparePriceEl && comparePriceEl.textContent.trim()) {
          stickyComparePrice.textContent = comparePriceEl.textContent.trim();
          stickyComparePrice.style.display = 'inline-block';
        }
      } else {
        const regularPriceEl = mainPriceWrapper.querySelector('.price__regular .price-item--regular, .price-item--regular, .price-item');

        if (regularPriceEl && regularPriceEl.textContent.trim()) {
          stickyPrice.textContent = regularPriceEl.textContent.trim();
        }
        if (stickyComparePrice) {
          stickyComparePrice.style.display = 'none';
        }
      }
    }

    // B. Sync Button State (Sold Out vs Add to Cart)
    if (mainAtcButton) {
      if (mainAtcButton.disabled) {
        stickyButton.setAttribute('disabled', 'true');
        stickyButton.textContent = mainAtcButton.textContent.trim() || 'Sold out';
      } else {
        stickyButton.removeAttribute('disabled');
        stickyButton.textContent = mainAtcButton.textContent.trim() || 'Add to cart';
      }
    }

    // C. Sync Image
    const mainImage = document.querySelector('.product__media img, .product-single__photo img');
    if (mainImage && stickyImage && mainImage.src) {
      stickyImage.src = mainImage.src;
    }
  }

  // ============================================
  // 2. SCROLL VISIBILITY LOGIC
  // ============================================
  let ticking = false;

  function updateStickyBar() {
    if (isDismissed) return;
    const rect = mainAtcButton.getBoundingClientRect();
    const isAboveViewport = rect.bottom < 0;

    if (isAboveViewport) {
      syncStickyWithMainProduct();
      stickyBar.classList.add('is-visible');
    } else {
      stickyBar.classList.remove('is-visible');
    }

    ticking = false;
  }

  function onScroll() {
    if (!ticking) {
      window.requestAnimationFrame(updateStickyBar);
      ticking = true;
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', updateStickyBar);

  // Click sticky button -> triggers main Add to Cart
  stickyButton.addEventListener('click', function () {
    mainAtcButton.click();
  });

  // ============================================
  // 3. SAFE LISTENERS FOR VARIANT CHANGES
  // ============================================

  // Trigger sync on any variant selection click/change
  function triggerSyncWithDelay() {
    // Check multiple times as Dawn asynchronously swaps the price HTML
    setTimeout(syncStickyWithMainProduct, 50);
    setTimeout(syncStickyWithMainProduct, 250);
    setTimeout(syncStickyWithMainProduct, 600);
  }

  document.addEventListener('change', function (e) {
    if (e.target.closest('variant-selects, variant-radios, form[action*="/cart/add"]')) {
      triggerSyncWithDelay();
    }
  });

  document.addEventListener('click', function (e) {
    if (e.target.closest('variant-radios label, .product-form__input label, swatch-input, .product-form__submit')) {
      triggerSyncWithDelay();
    }
  });

  // Target ONLY the product section for DOM changes (ignoring sticky bar changes)
  const productSection = document.querySelector('section[id*="main-product"], .product');
  if (productSection) {
    const safeObserver = new MutationObserver(function (mutations) {
      // Ignore mutations originating from inside the sticky bar itself
      const isStickyMutation = mutations.some(m => stickyBar.contains(m.target));
      if (!isStickyMutation) {
        syncStickyWithMainProduct();
      }
    });

    safeObserver.observe(productSection, {
      childList: true,
      subtree: true
    });
  }

  // Initial Sync on load
  updateStickyBar();
  syncStickyWithMainProduct();
});